"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_API_KEY = void 0;
exports.TOKEN_API_KEY = 'token.api';
